module.exports = {
    "title": "Deal Insights",
    "sub_text": "A snapshot of all your deals in one place",
    "cards": {
        "active_deals": "Total number of active deals",
        "revenue": "Value by revenue",
        "average_confidence": "Average Confidence",
    },
    "filters": {
        "all_deals": "All Deals",
        "deals_on_target": "Deals on target",
        "deals_slipping_away": "Deals slipping away",
        "deals_at_risk": "Deals at risk",
    },
    
    "headers": {
        "all_deals": {
            "title": "All Deals",
            "deal_title": "Deal Name",
            "customer": "Account",
            "value": "Deal Value",
            "ai_probability": "Paperflite Prediction",
            "team_confidence": "Team's Confidence",
            "creation_date": "Creation Date",
            "owner": "Deal Owner",
            "expected_close_date": "Expected Close Date",
            "last_activity": "Last Activity"
        }
    },
    "empty_message": { 
        "title": "Where is everybody?",
        "message": "Looks like you've not initiated a conversation yet. Go on, say hi!.",
    },
    "deal_details": {
        "signals_gaps": "Signals & Gaps",
        "crm_url": "View in CRM",
        "content_shared":{
            "share": "Content shared",
            "no_activity": "No activity recorded",
        },
        "collections":{
            "show_less": "Show less",
            "show_all": "Show all"
        },
        "assets":{
            "show_less": "Show less",
            "show_all": "Show all"
        },
        "graph": {
            "ai_probability": "AI Probability",
            "last_activity": "Last activity ",
            "tool_tip": {
                "probability": "Win Probability"
            } 
        },
        "infographic_view": {
            "title": "Infographic view",
            "won": "Won Distribution",
            "lost": "Lost Distribution"
        },
        "integrate_salesforce": {
            "title": "Integrate Salesforce",
            "message": " You have not integrated to any of the services now kindly"
        },
        "card": {
            "total_revenues": "Total Revenue",
            "days_remaining": "Days Remaining",
            "invalid_date": "Invalid date"
        },
        "timeline": {
            "title": "Timeline",
            "view_asset": "viewed the asset",
            "downloaded": "downloaded the asset",
            "view_collection": "viewed the collection",
            "deal_update": "Deal stage has been updated to",
            "lead_capture": "Lead captured",
            "reshare_collection": "reshared the collection",
            "reshare_asset": "reshared the asset",
            "link_clicked": "clicked on your content",
            "email_open" : "opened your email",
            "asset_added": "added the asset"
        },
        
    }
}


